<template>
  <div class="container" v-if="!!data">
    <p class="heading-tertiary-main">История запросов</p>
    <div class="history">
      <div class="history__header">
        <div class="column--small">пп</div>
        <div class="column">Дата запроса</div>
        <div class="column">Раздел</div>
        <div class="column">Отчет</div>
        <!-- <div class="column"></div> -->
      </div>
      <div
        class="history__item"
        v-for="(dataItem, index) in data.data"
        v-bind:key="index"
      >
        <div class="column--small">{{ computeIndex(index) }}</div>
        <div class="column dateColumn">
          {{ dataItem.date | getDate }}
          <span class="text--grey">{{ dataItem.date | getTime }}</span>
        </div>
        <div class="column groupColumn">
          {{ getReportGroupName(dataItem.report__group) }}
        </div>
        <div class="column column--bold reportColumn">
          <router-link
            :to="{ name: 'chartReport', params: { id: dataItem.report__id } }"
            >{{ dataItem.report__name }}</router-link
          >
        </div>
        <div class="column column--bold reportMobileColumn">
          {{ dataItem.report__name }}
        </div>
        <div class="column actionColumn">
          <router-link
            :to="{ name: 'chartReport', params: { id: dataItem.report__id } }"
            >Перейти на отчет</router-link
          >
        </div>
        <!-- <div class="column"><button class="button button--primary"> <img src="../../assets/icons/refresh.svg" alt="" class="button__icon"> Повторить запрос</button></div> -->
      </div>
      <div class="history__pagination" v-if="!pageCount <= 1">
        <paginate
          :page-count="pageCount"
          :page-range="1"
          :margin-pages="1"
          :click-handler="paginate"
          :prev-text="'Предыдущее'"
          :next-text="'Следующее'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :prev-class="'pagination__item pagination__item--link'"
          :next-class="'pagination__item pagination__item--link'"
          :active-class="'pagination__item pagination__item--active'"
          :disabled-class="'pagination__item pagination__item--disabled'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import history_api from "@/api/history";
import Paginate from "vuejs-paginate";

export default {
  components: {
    Paginate,
  },
  data() {
    return {
      data: null,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.data.cnt / 10);
    },
    page() {
      return this.$route.params.page;
    },
  },
  watch: {
    $route(to) {
      this.params = {
        page: to.params.page,
      };
      this.getHistoryList();
    },
  },
  mounted() {
    this.getHistoryList();
  },
  methods: {
    getHistoryList() {
      history_api(this.page).then((data) => {
        this.data = data.result;
      });
    },
    getReportGroupName(group_id) {
      return group_id === 2
        ? "Бизнес-кредитование"
        : group_id === 1
        ? "Розничное кредитование"
        : "Общее кредитование";
    },
    async paginate(event) {
      await this.$router.push({
        params: { page: event },
      });
    },
    computeIndex(index) {
      return (this.page - 1) * 10 + index + 1;
    },
  },
};
</script>

<style lang="scss">
*:focus {
  outline: none;
}
.history__wrapper {
  max-width: 1110px;
  width: 100%;
  margin: auto;
  padding: 0 45px;
}
.history {
  border-radius: 30px 30px 30px 30px;
  margin-bottom: 17.4rem;
  overflow: hidden;
  &__header {
    background: #00557c;
    height: 6.4rem;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 1.4rem;
    color: #ffffff;
    padding: 2rem 0 2rem 2.4rem;
  }
  &__item {
    //height: 6.4rem;
    display: flex;
    align-items: center;
    padding: 2rem 2rem 2rem 2.4rem;
    &:nth-child(odd) {
      background-color: #f4fbff;
    }
  }
  &__pagination {
    display: flex;
    justify-content: center;
    margin-top: 10rem;
  }
  .actionColumn {
    display: none;
  }
  .reportMobileColumn {
    display: none;
  }

  @media only all and (max-width: 900px) {
    &__header {
      display: none;
    }
    &__item {
      display: block;
      background-color: #f4fbff;
      margin-bottom: 20px;
      border-radius: 16px;
      overflow: hidden;
      padding: 0;
      .column--small {
        display: none;
      }
      .dateColumn {
        background-color: #00557c;
        color: #fff;
        padding: 10px 20px;
        .text--grey {
          color: #ffffff80;
        }
      }
      .groupColumn {
        padding: 7px 20px;
        font-weight: bold;
      }
      .reportColumn {
        display: none;
      }
      .reportMobileColumn {
        display: block;
        padding: 7px 20px;
        background-color: #ffffff;
        font-weight: normal;
      }
      .actionColumn {
        display: block;
        padding: 13px 20px;
        a {
          font-weight: bold;
          color: #005177;
        }
      }
    }
  }
}
@media only all and (max-width: 900px) {
  .history {
    border-radius: 0;
  }
}
.column {
  flex: 1;
  & > a {
    text-decoration: none;
    border-bottom: 1px dashed #000;
    transition: 0.1s all;
    color: inherit;
    line-height: 150%;
    &:hover {
      border-bottom: 1px dashed transparent;
    }
  }
  &--small {
    flex-basis: 6%;
  }
  &--bold {
    font-weight: 600;
  }
}

.button {
  background: #0082be;
  border-radius: 3rem;
  height: 5rem;
  color: #ffffff;
  padding: 1.5rem 2.5rem;
  border: none;
  font-weight: 700;
  font-size: 1.4rem;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all;
  &:focus {
    outline: none;
  }
  &__icon {
    margin-right: 1.8rem;
  }
  &:hover {
    background: #005177;
  }
  &:active {
    background: #005177;
    box-shadow: inset 10px 10px 30px rgba(0, 34, 50, 0.5);
  }
  &:disabled {
    background: #b2e7ff;
  }
}
.pagination {
  display: flex;
  align-items: center;
  list-style: none;
  flex-wrap: wrap;
  &__item {
    background: #0082be;
    color: white;
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 1.6rem;
    margin-bottom: 10px;
    & > a {
      display: flex;
      cursor: pointer;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
    &--link {
      width: 15rem;
    }
    &--active {
      background-color: #fff;
      color: #0082be;
      border: 1px solid black;
    }
    &--disabled {
      opacity: 0.6;
    }
  }
}
</style>
